import React from 'react';


/**
 *
 * @param {HTMLElement} el
 * @return {{top: number, left: number}}
 */
const getDocumentOffsetPosition = (el) => {
    const position = {
        top: el.offsetTop,
        left: el.offsetLeft
    };
    if (el.offsetParent) {
        const parentPosition = getDocumentOffsetPosition(el.offsetParent);
        position.top += parentPosition.top;
        position.left += parentPosition.left;
    }
    return position;
};


/**
 *
 * @param {HTMLElement} el
 * @return {boolean}
 */
function checkIsElementInViewportParticularly(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth)
    );
}


export {
    getDocumentOffsetPosition,
    checkIsElementInViewportParticularly,
};
